import debounce from 'lodash/debounce';
import * as React from 'react';
import { useVariableWithStableRef } from './useVariableWithStableRef';

export function useDebounce(callback: () => void, debounceTime: number) {
    const handlerRef = useVariableWithStableRef(callback);

    return React.useCallback(
        debounce(() => handlerRef.current?.(), debounceTime),
        [handlerRef]
    );
}
